import { createRouter,createWebHashHistory,createWebHistory } from 'vue-router'
import LayoutDefault from "../layout/index.vue";

const routes = [
  {
    path:'/',
    name:'Home',
    component:LayoutDefault,
	redirect: "/Home",
    meta:{
      iconClass: "iconfont icon-home",
      title: "首页",
    },
	children: [
	  {
	    path: "/Home",
	    component: () => import("../views/Home/index.vue"),
	    name: "Home",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "首页",
	    },
	  },
    {
	    path: "/MenuManagement",
	    component: () => import("../views/MenuManagement/index.vue"),
	    name: "MenuManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "菜单管理",
	    },
	},
    {
	    path: "/RoleManagement",
	    component: () => import("../views/RoleManagement/index.vue"),
	    name: "RoleManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "角色权限管理",
	    },
	},
    {
	    path: "/AdminManagement",
	    component: () => import("../views/AdminManagement/index.vue"),
	    name: "AdminManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "管理员列表",
	    },
	},
    {
	    path: "/IpBlackManagement",
	    component: () => import("../views/IpBlackManagement/index.vue"),
	    name: "IpBlackManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "IP黑名单",
	    },
	},
    {
	    path: "/LogManagement",
	    component: () => import("../views/LogManagement/index.vue"),
	    name: "LogManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "日志管理",
	    },
	},
    {
	    path: "/NewsManagement",
	    component: () => import("../views/NewsManagement/index.vue"),
	    name: "NewsManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "西乳新闻",
	    },
	},
    {
	    path: "/BulletinManagement",
	    component: () => import("../views/BulletinManagement/index.vue"),
	    name: "BulletinManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "公告通知",
	    },
	},
    {
	    path: "/PoliciesRegulationsManagement",
	    component: () => import("../views/PoliciesRegulationsManagement/index.vue"),
	    name: "PoliciesRegulationsManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "政策法规",
	    },
	},
    {
	    path: "/PartyBuildingCultureManagement",
	    component: () => import("../views/PartyBuildingCultureManagement/index.vue"),
	    name: "PartyBuildingCultureManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "党建文化",
	    },
	},
    {
	    path: "/ImageManagement",
	    component: () => import("../views/ImageManagement/index.vue"),
	    name: "ImageManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "图片及位置管理",
	    },
	},
    {
	    path: "/VideoManagement",
	    component: () => import("../views/VideoManagement/index.vue"),
	    name: "VideoManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "视频及位置管理",
	    },
	},
    {
	    path: "/DictionaryManagement",
	    component: () => import("../views/DictionaryManagement/index.vue"),
	    name: "DictionaryManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "字典管理",
	    },
	},

	{
	    path: "/CommodityManagement",
	    component: () => import("../views/CommodityManagement/index.vue"),
	    name: "CommodityManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "品牌及商品列表",
	    },
	},
	{
	    path: "/CommodityTypeManagement",
	    component: () => import("../views/CommodityTypeManagement/index.vue"),
	    name: "CommodityTypeManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "产品类型管理",
	    },
	},
	{
	    path: "/CommodityTrademarkManagement",
	    component: () => import("../views/CommodityTrademarkManagement/index.vue"),
	    name: "CommodityTrademarkManagement",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "产品商标管理",
	    },
	},
	
	



	]
  },
  {
    path: "/Login",
    component: () => import("@/views/Login/index.vue"),
    name: "Login",
    hidden: true,
    meta: {
      title: "登录",
    },
  },
]

const router = createRouter({
	//createWebHistory = 没有#号
	//createWebHashHistory = 有#号
	history: createWebHistory(),
	routes
})

export default router
